import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";

export const CopyEventModal = ({ show, data, toggle, onSubmit }) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    eventName: "",
  });

  const { eventName } = formData;

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      eventName: data.eventName,
    }));
  }, [data]);

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onApply = async () => {
    await onSubmit(formData);
    toggle();
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">{t("auth.event.copyEventTitle")}</h5>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="">{t("common.label.name")}</label>
          <input
            type="text"
            className="form-control plutoinput-form-control"
            name="eventName"
            value={eventName}
            onChange={handleChange}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={toggle}
        >
          {t("common.button.cancel")}
        </button>
        <button type="button" className="btn btn-primary" onClick={onApply}>
          {t("common.button.save")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
